<mat-dialog-content class="mat-typography" style="overflow: visible">
    <app-mensaje-importante class="in-dialog"></app-mensaje-importante>
    <div style="text-align: center;">
        <p *ngIf="data.visibilidad.mostrarMensajeCategoriasPeqDivididas" style="text-align: center; margin: 0;">
            En el FTyC subdividimos la categoría <strong>PEQUEÑA</strong>
            <br/>en <strong>PEQUEÑA TRAMO 1 y PEQUEÑA TRAMO 2</strong> para mejorar aún más
            <br/>las condiciones financieras.<br/><br/>
        </p>

        <h2>El máximo para tu categoría <b>{{ data.categoria.nombre }}</b> es
            <b>{{ data.monto | currency : '$' : 'symbol' : '1.0-0' }}</b></h2>
        <h3 *ngIf="data.visibilidad.mostrarMensajeSuperarMontoMaximo">
            Podés superarlo sin problemas<br/>
            Sólo cambiarán las condiciones financieras :)
        </h3>
        <p>
            <b>Recordá que con éste crédito podés financiar hasta</b><br/>
            el {{ data.porcentajeInversion }}% del total de tu
            proyecto{{ data.sinIva ? ' sin iva' : '' }}{{ data.porcentajeInversion < 100 ? ', el resto deberá ser aporte propio' : '' }}
            .
        </p>
    </div>
</mat-dialog-content>
<mat-dialog-actions style="justify-content: center">
    <button (click)="data.stepper.next()" mat-button mat-dialog-close class="boton-gris-ftyc">Entendido</button>
</mat-dialog-actions>
